import React from 'react'
import { YapContentBuilder, YapContentPreview, YapAssetCatalogue, YapPage, YapHeader, YapHeaderButton as CBHeaderButton, YapContentValidations, YapAssetImage as CBAssetImage, useYapPageState as useCBPageState, YapContentBuilderIconProviderContext as CBMessageBuilderIconProviderContext } from '@yapstudios/yap-content-builder'
import {  YapContentPreviewsModal } from '@yapstudios/yap-content-builder'
import '@yapstudios/yap-content-builder/dist/index.css'
import { templateLibrary, ImageAndTextTemplate, DefaultMessageTemplate } from './CollegeboardTemplateLibrary.js'
import { components, componentTemplates, MessageHeaderComponent, TextComponent, SingleImageComponent, LearnMoreButtonComponent, ActionButtonComponent, RequestInformationButtonComponent, UniversityComponent } from './CollegeboardComponentLibrary.js'
import { allPreviews, CollegeboardAssetPreviewLibrary } from './CollegeboardAssetPreviewLibrary.js';
import { assetTemplates as defaultAssetTemplates } from './CollegeboardAssetTemplateLibrary.js';

import CBMessageFeedPreview from './CBMessageFeedPreview.js'
import CBInstitutionPreview from './CBInstitutionPreview.tsx'
import CBMessagePreview from './CBMessagePreview.js'
import { CBSavedListPreview, CBCollegeListPreview } from './CBCollegeListPreview.tsx'

import { convertToPage, convertFromPage } from "./MessageConvert.js"
import { avatarPreviews, wordmarkPreviewsLight, wordmarkPreviewsDark, headerPreview } from "./CollegeboardAssetPreviewLibrary.js"
import CBIconProvider from "./CBIconProvider.js"
import { styles, fonts } from "./CBStyles.js"
import './styles.css'

/**
 * Presents an interface to allow messages to be created and edited 
 * @param {pages} Pages data
 * @param {onPagesUpdated} Callback when page data is updated
 * @returns {React.ReactElement} The view
 */
const CBMessageBuilder = (props) => {
    const [pages, setPages] = React.useState(null)

    const defaultTemplate = props.defaultTemplate ?? new DefaultMessageTemplate()

    const onPagesUpdated = (newPages) => {
        if (props.onPagesUpdated) {
            props.onPagesUpdated(newPages)
        }
        setPages(newPages)
    }


    return (
        <CBIconProvider>
            <YapContentBuilder components={components}
                componentTemplates={null}
                onPagesUpdated={onPagesUpdated}
                defaultTemplate={defaultTemplate}
                templates={null}
                styles={styles}
                onAssetImport={props.onAssetImport}
                {...props}
                pages={props.pages ?? pages}
            />
        </CBIconProvider>
    )
}

/**
 * Asset Catalogue
 * 
 * @param   {dictionary} assets <description>
 * @param   {function} onAssetSelected <description>
 * @param   {function} onFileSelected <description>
 * @returns {React.ReactElement} The view
 */
const CBAssetCatalog = ({ assets, assetTemplates, previewAssetPath, previewCallback, canCrop, canMultiUpload, onAssetSelected, onAssetDelete, onAssetChange, onFileSelected, assetLibrary, onAssetLibraryDelete, onAssetLibraryImport, onAssetLibraryChange }) => {

    if (assets == null) {
        throw Error('CBAssetCatalog requires assets property')
    }

    CollegeboardAssetPreviewLibrary._previewCallback = previewCallback

    return (
        <CBIconProvider>
            <YapAssetCatalogue previews={allPreviews}
                assets={assets}
                assetTemplates={assetTemplates ?? defaultAssetTemplates}

                onAssetSelected={onAssetSelected}
                onAssetChange={onAssetChange}
                onAssetDelete={onAssetDelete}

                onFileSelected={onFileSelected}

                previewAssetPath={previewAssetPath}

                assetLibrary={assetLibrary}
                onAssetLibraryDelete={onAssetLibraryDelete}
                onAssetLibraryImport={onAssetLibraryImport}
                onAssetLibraryChange={onAssetLibraryChange}

                canCrop={canCrop}
                canMultiUpload={canMultiUpload}
            />
        </CBIconProvider>
    )
}

/**
 * Page component that manages page contnet for CBMessageBuilder & CBAssetCatalog content. 
 * Currently is just a name wrapper around YapPage but is a placeholder here to have more specific CB customisation in the future.
 * @param {*} props 
 * @returns {React.ReactElement} The view
 */
const CBPage = (props) => {
    return <YapPage defaultContainerClassName={""} {...props} />
}

/**
 * Header component that renders a header for CBMessageBuilder & CBAssetCatalog content. 
 * Currently is just a name wrapper around YapHeader but is a placeholder here to have more specific CB customisation in the future.
 * @param {*} props 
 * @returns {React.ReactElement} The view
 */
const CBHeader = (props) => {
    return <YapHeader {...props} />
}

const CBContentPreviewsModal = (props) => {
    return <YapContentPreviewsModal allowFocus={true} {...props} />
}



export { CBMessageBuilder, CBContentPreviewsModal, CBPage, CBHeader, CBAssetCatalog }